import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE ,API_URLBLAZEOLD} = environment;

@Injectable({
  providedIn: 'root'
})

export class ProductService {

    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    saveProduct(productData: any) {
        const url = `${API_URLBLAZE}/product/save`;
        return this.http.post(url, productData).pipe(catchError(this.handleError()));
    }

    updateProduct(productData: any) {
      const url = `${API_URLBLAZE}/product/edit`;
      return this.http.post(url, productData).pipe(catchError(this.handleError()));
    }

    updateProductSlab(productSlab: any) {
      const url = `${API_URLBLAZE}/product/edit-mapping`;
      return this.http.post(url, productSlab).pipe(catchError(this.handleError()));
    }

    getProfileImage(profileName: any) {
      const url = `${API_URLBLAZE}/product/icon/get-profile?url=${profileName}`;
      return this.http.get(url, { responseType: 'blob' as 'json' }).pipe(catchError(this.handleError()));
    }

    getProductList(productName:String,categoryName:String,subCategory:String, country:String,status:String,page_size:number,page_no:number,sort:string,columnName:string) {
      var url = "";
      var filter = "";
      if(productName != ""){
        filter = filter+`&name=${productName}`
      }
      if(categoryName != ""){
        filter = filter+`&productSubCategory.productCategory.name=${categoryName}`
      }
      if(subCategory != ""){
        filter = filter+`&productSubCategory.name=${subCategory}`
      }
      if(country != ""){
        filter = filter+`&country=${country}`
      }
      if(status != ""){
        filter = filter+`&status=${status}`
      }
      if(sort != ""){
        filter = filter+`&sort_dir=${sort}`
      }
      if(columnName != ""){
        filter = filter+`&sort_column=${columnName}`
      }
      url = `${API_URLBLAZE}/product/page?page_size=${page_size}&page_no=${page_no}`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get exchange rate audit trail
    getProductSlabAuditTrail(product:String,pageSize:number,pageNumber:number) {
      var url = "";
      var filter = "";
      if(product != null){
        filter = filter+`&after%5B"product_id"%5D=${product}`
      }
      url = `${API_URLBLAZEOLD}/audit-trail?entity=product_slab&page_size=${pageSize}&page_no=${pageNumber}&sort_dir=DESC&sort_column=eventTimestamp`+filter;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    getProductById(id: number) {
      const url = `${API_URLBLAZE}/product/`+id;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    getSubCategoryDropdownById(id:any) {
      const url = `${API_URLBLAZE}/product/product-subcategory/category/`+id;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    getProductSlab(productId:any, countryId:any) {
      const url = `${API_URLBLAZE}/product/${productId}/${countryId}`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

   
    getCountryDropdown() {
      const url = `${API_URLBLAZE}/product/country/active?page_size=ALL`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    reviewProductSlab(slabData:any) {
      const url = `${API_URLBLAZE}/product/product-slab/edit`;
      return this.http.post(url,slabData).pipe(catchError(this.handleError()));
    }

    reviewCountryMapping(countryMappingData:any) {
      const url = `${API_URLBLAZE}/product/product-country/edit`;
      return this.http.post(url,countryMappingData).pipe(catchError(this.handleError()));
    }

    deleteCountryMapping(productId:any,countryId : any) {
      const url = `${API_URLBLAZE}/product/product-country/delete?product=${productId}&country=${countryId}`;
      return this.http.delete(url).pipe(catchError(this.handleError()));
    }

    productStatusChange(productId:any,status :any) {
      const url = `${API_URLBLAZE}/product/status?productId=${productId}&status=${status}`;
      return this.http.patch(url,null).pipe(catchError(this.handleError()));
    }

    categoryStatusChange(categoryId:any,status :any) {
      const url = `${API_URLBLAZE}/product/product-category?categoryId=${categoryId}&status=${status}`;
      return this.http.patch(url,null).pipe(catchError(this.handleError()));
    }

    subCategoryStatusChange(subCategoryId:any,status :any) {
      const url = `${API_URLBLAZE}/product/product-subcategory?subCategoryId=${subCategoryId}&status=${status}`;
      return this.http.patch(url,null).pipe(catchError(this.handleError()));
    }

      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}